import React from 'react';
import { Box, Button, Card, Grid, TextField, Typography,FormControl,InputLabel,Select,MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 1100,
  borderRadius: 16,
  boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
}));

const VishingStep1 = ({ projectName, setProjectName, organizationId, setOrganizationId, organizations, onNext, onBack }) => (
  <Box sx={{ width: '100%', p: { xs: 2, md: 3 }, display: 'flex', justifyContent: 'center' }}>
    <SectionCard sx={{ p: 3 }}>
      <Grid container spacing={3}>
        {/* Left: Form */}
        <Grid item xs={12} md={7}>
          <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
            Campaign Details
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Give your vishing campaign a clear, searchable name.
          </Typography>

          <TextField
            fullWidth
            label="Campaign Name"
            placeholder="e.g., Acme – Vishing – Q3"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <FormControl fullWidth>
                <InputLabel id="org-select-label">Organization</InputLabel>
                <Select
                labelId="org-select-label"
                label="Organization"
                value={organizationId}
                onChange={(e) => setOrganizationId(Number(e.target.value))}
                >
                {organizations.map((org) => (
                    <MenuItem key={org.id} value={org.id}>
                    {org.name}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>

          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button variant="outlined" onClick={onBack}>Back</Button>
            <Button variant="contained" onClick={onNext} disabled={!projectName.trim()}>
              Next
            </Button>
          </Box>
        </Grid>

        {/* Right: Tips panel */}
        <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box
            sx={{
              width: '100%',
              minHeight: 220,
              borderRadius: 3,
              p: 3,
              bgcolor: 'rgba(0,0,0,0.04)',
              border: '1px dashed rgba(0,0,0,0.12)'
            }}
          >
            <Typography fontWeight={700} sx={{ mb: 1 }}>
              Tips
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Use a name like “Acme – Vishing – Sept”. You can refine scope next.
            </Typography>
            <Box component="ul" sx={{ mt: 1.5, pl: 3, m: 0 }}>
              <Box component="li">
                Define target groups (support, finance, execs).
              </Box>
              <Box component="li">
                Pick caller ID strategy (spoofed vs. dedicated).
              </Box>
              <Box component="li">
                Note time windows &amp; time zones.
              </Box>
              <Box component="li">
                Prepare disclosure line &amp; recording policy.
              </Box>
              <Box component="li">
                Decide script style (conversational vs. structured).
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </SectionCard>
  </Box>
);

export default VishingStep1;
